(() => {
  'use strict';
  if (window.Sn75Optimisation) return;

  const strips = new Set();
  const paused = new Set();
  const motionTargets = '.sn21-hero__picture img, .sn17-feature__media, .sn17-feature__copy, .sn17-card, .sn17-story-view, .sn17-story-media, .sn17-story-copy';
  const visible = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.removeAttribute('data-sn75-offscreen');
      else entry.target.setAttribute('data-sn75-offscreen', '');
    });
  }, { rootMargin: '120px 0px', threshold: 0 }) : null;

  const init = scope => {
    const roots = [...scope.querySelectorAll('[data-sn26-media-strip]')];
    if (scope.matches?.('[data-sn26-media-strip]')) roots.unshift(scope);
    roots.forEach(root => {
      if (strips.has(root)) return;
      strips.add(root);
      visible?.observe(root);
    });
  };
  const visibility = () => {
    if (document.hidden) {
      document.documentElement.setAttribute('data-sn75-inactive', '');
      document.getAnimations?.().forEach(animation => {
        if (animation.playState !== 'running' || !animation.effect?.target?.matches?.(motionTargets)) return;
        animation.pause();
        paused.add(animation);
      });
    } else {
      document.documentElement.removeAttribute('data-sn75-inactive');
      paused.forEach(animation => {
        if (animation.playState === 'paused' && animation.effect?.target?.isConnected) animation.play();
      });
      paused.clear();
    }
  };
  const destroy = scope => strips.forEach(root => {
    if (root === scope || scope.contains(root)) {
      visible?.unobserve(root);
      root.removeAttribute('data-sn75-offscreen');
      strips.delete(root);
    }
  });

  window.Sn75Optimisation = { init, destroy };
  document.addEventListener('visibilitychange', visibility);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  const boot = () => { init(document); visibility(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
